import React from 'react'
import jobsList from '../../Main/Reducers/JobList'

export const { Provider, Consumer } = React.createContext()

const initialState = {
  index: 0,
  selectedJob: null,
  jobs: [],
  unreadMessages: {},
  jobStatistics: {
    assignedJobs: 0,
    unviewedJobs: 0,
    viewedJobs: 0,
    myAssignedJobs: 0
  },
  showAssignedJobs: false
}

export function StoreJobList(props) {
  const [state, dispatch] = React.useReducer(jobsList, initialState)
  const value = {
    state,
    dispatch
  }
  return <Provider value={value}>{props.children}</Provider>
}
